import React from 'react'
import PropTypes from 'prop-types'
import { Section, MainSection } from './Wrappers'

const MainSectionDefault = props => {
    const { children } = props

    return (
        <MainSection>
            <Section>{children}</Section>
        </MainSection>
    )
}

MainSectionDefault.propTypes = {
    children: PropTypes.node,
}

export { MainSectionDefault }
